import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import colors from "../constants/Colors";

import { reset_password } from '../../services/auth';
import { Navigate, useNavigate } from "react-router-dom";
import { ArrowBackIosNew } from "@mui/icons-material";

const defaultTheme = createTheme();

export default function Cover() {


  const [email, setEmail] = useState("");
  const navigate = useNavigate()


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("email", email)
    reset_password(email);

  };



  return (

    <Box
      sx={{
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: '#1976d2' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography variant="h5" style={{fontWeight:'800',color:'#1976d2'}}>
          Reset password
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit}
        sx={{ mt: 3 }}
      >

        <TextField
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, backgroundColor: colors.primary }}
        >
         Reset
        </Button>
        <ArrowBackIosNew style={{marginTop:10}} fontSize="9px"/>
        <a style={{ cursor: 'pointer' ,marginTop:-20 }} onClick={() => navigate(-1)}>  Go back</a>
      </Box>
    </Box>

  );
}
